export class CreateApplePayWebSessionRequest {
	merchantKey: number;
}
